var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"id":"base-breadcrumb","separator-class":"el-icon-arrow-right"}},[(_vm.breadcrumbList.length)?[_c('img',{staticClass:"img-icon",attrs:{"src":require(("../assets/static/img/layout/" + (_vm.breadcrumbList[0].icon) + ".black.png"))}})]:_vm._e(),_vm._l((_vm.breadcrumbList),function(ref,index){
var path = ref.path;
var name = ref.name;
return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: path }}},[_vm._v("\n    "+_vm._s(name)+"\n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }